import { render, staticRenderFns } from "./virtualConversationDetails.vue?vue&type=template&id=5756da2a&scoped=true"
import script from "./virtualConversationDetails.vue?vue&type=script&lang=js"
export * from "./virtualConversationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5756da2a",
  null
  
)

export default component.exports